import type { AddressLike } from '@plato/data/model/address';
import { MapPinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { buildGoogleMapsSearchUrl } from '../../lib/google-maps-url.ts';
import { cn } from '../../lib/utils.ts';
import { buttonVariants } from '../ui/button.tsx';

export type GoogleMapsLinkProps = {
    address: AddressLike;
    className?: string;
};

export const GoogleMapsLink = ({ address, className }: GoogleMapsLinkProps) => {
    const mapsUrl = buildGoogleMapsSearchUrl(address);
    if (!mapsUrl) {
        return null;
    }

    return (
        <Link
            to={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
                buttonVariants({
                    variant: 'link',
                }),
                'p-0 h-lh',
                className,
            )}
        >
            <MapPinIcon className="h-4 w-4" />
        </Link>
    );
};
